export const PASSWORD_REQUIREMENTS_MESSAGE =
  "Your password must be at least 5 characters long.";

export const INVALID_RESET_LINK_MESSAGE =
  "This password reset link is invalid or has expired. Please request a new one.";

export const isStrongPassword = (value = "") => {
  const password = String(value || "");

  return password.length >= 5;
};

export const getResetToken = ({ search = "", state = null } = {}) => {
  const queryToken = new URLSearchParams(search).get("token");
  return String(queryToken || state?.reset_token || "").trim();
};
